import Backbone from "backbone";
import _ from "underscore";
import { dispatcher, DispatcherEvents } from "../../utils/dispatcher";
import template from "./selectList.tmpl";

interface ISelectListConstructorOptions extends Backbone.ViewOptions<Backbone.Model> {
    title: string;
    selectCallback?: (item: ISelectListOptions | null) => void;
}

export interface ISelectListOptions {
    name: string;
    id: string;
    iconHtml?: string;
    isSelected?: boolean;
    translate?: boolean;
    template?: string;
}

interface IItemList {
    handler: (e: Event) => void;
    item: HTMLLIElement;
}

const isKeyboardEvent = (e: Event): e is KeyboardEvent => {
    return !!(<KeyboardEvent>e).keyCode;
};

export default class SelectList extends Backbone.NativeView<Backbone.Model> {
    private readonly title: string;
    private readonly selectCallback;
    private readonly itemList: IItemList[] = [];
    private readonly template  = _.template(template);

    constructor (options: ISelectListConstructorOptions) {
        super(options);
        this.selectCallback = options.selectCallback;
        this.title = options.title;
    }

    create (options: ISelectListOptions[] = []) {
        this.el.innerHTML = this.template({ title: this.title, options });
        return this;
    }

    render (options: ISelectListOptions[] = [], createFirst = true) {
        if (createFirst) {
            this.create(options);
        }

        let items: NodeListOf<HTMLLIElement> = this.el.querySelectorAll(".checklist__item");
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            let handler = (e: Event) => {
                let id = e && e.currentTarget && (<HTMLLIElement>e.currentTarget).getAttribute("data-id");
                if (id && (!isKeyboardEvent(e) || e.keyCode === 32 || e.keyCode === 13)) {
                    dispatcher.trigger(DispatcherEvents.DriveAppInteraction, e);
                    let thisItem = options.filter(option => option.id === id)[0];
                    this.selectCallback && this.selectCallback(thisItem || null);
                }
            };
            item.addEventListener("keypress", handler, false);
            item.addEventListener("click", handler, false);
            this.itemList.push({ item, handler });
        }
        return this;
    }

    remove () {
        this.itemList.forEach(itemObject => {
            itemObject.item.removeEventListener("click", itemObject.handler, false);
            itemObject.item.removeEventListener("keypress", itemObject.handler, false);
        });
        super.remove();
        return this;
    }
}